<template>
    <v-app id="app">
    
        <v-container class="my-15 px-10 text-body-1 mt-lg-5 mt-5 monsterrat">
          
                <v-layout row>
                  <!-- <v-flex lg12 class="text-lg-body-2" >
                               <a href="/leveltest">  
                                  <v-icon small color="grey"> mdi-arrow-left </v-icon> <span class="grey--text font-weight-medium"> BACK </span>

                            </a>
                </v-flex> -->
                   
                    <v-flex lg12 class="mt-lg-14 mt-10">

                         <v-row>
                            <v-col>
                              <p class="text-sm-h4 text-h5 text-md-h2 font-weight-bold"> <span> Level Test <span class="font-color1 font-weight-black"> 레벨테스트 </span> </span> </p>
                           
                              
                            </v-col>
                      </v-row>

                      <v-layout row wrap class="mt-5" justify-sm-center>

                            <v-flex xs12 lg6 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 1. Introduction <span class="font-color1 font-weight-black"> 소개 </span> </span></p> 
                                
                                  <v-card class="px-2 py-lg-6 pb-lg-7 py-md-10 py-10  deep-purple lighten-5 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <div class="font-weight-bold"> 다음 질문에 답해주세요. </div>
                                                        <div class="mt-lg-2 text-body-2"> Please answer the following questions.</div>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="white px-5 py-5 elevation-0">
                                                    <p >
                                                        1. What is your name?

                                                    </p>
                                                    <p >
                                                        2. How old are you?

                                                    </p>
                                                    <p >
                                                        3. Where do you live?

                                                    </p>
                                                    <p >
                                                       4. What are your hobbies?

                                                    </p>
                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                            <v-flex xs12 lg6 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 2. Repetition <span class="font-color1 font-weight-black"> 반복</span> </span></p> 
                                
                                  <v-card class="px-2 py-lg-6 pb-lg-4 py-md-5 py-10 deep-purple lighten-5 elevation-0 rounded-xl">

                                        <v-container fluid class="px-lg-15 py-lg-12 py-10 text-center">


                                              <div class="font-weight-bold">
                                                  <div> 선생님이 문장을 들려줄 거예요. </div>
                                                  <div class="mt-lg-2"> 잘듣고. </div>
                                                  <div class="mt-lg-2"> 문장을 따라 해주세요. </div>
                                              </div>


                                              <div class="mt-lg-10 mt-5 text-lg-body-2 text-body-2">
                                              In this part, the instructor will give you sentences.
                                              <br /> <div class="mt-lg-0 mt-2"> Listen carefully. </div>
                                             <div class="mt-lg-0 mt-2"> Please repeat exactly how you heard the sentences. </div>
                                              </div>
                                        </v-container>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>



                            
                            <v-flex xs12 lg12 md12>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 3. Sentence Construction <span class="font-color1 font-weight-black"> 문장구조</span> </span></p> 
                                
                                  <v-card class=" py-lg-10 pb-lg-13 py-md-10 py-10 deep-purple lighten-5 elevation-0 rounded-xl">

                                    <v-list-item class="ml-3">

                                                      <v-list-item-content>
                                                        <div class="font-weight-bold"> 선생님이 2개 단어를 선택해 줄 거에요. 각 단어로 문장을 만들어보세요. </div>
                                                        <div class="mt-2 text-body-2"> Make one sentence for each word given. The teacher will choose only two (2) words.</div>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                         <v-layout wrap justify-center>
                                            <v-flex xs12 lg12>
                                                
                                                  
                                                        <v-row class="mt-2 px-2">
                                                            <v-col cols="6" md="2" sm="1" class="mt-sm-4 mt-0">
                                                                <v-card class="py-5 px-2 elevation-0">
                                                                   <v-img src="../../../assets/images/LevelTest/leveltest/music.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg4 md2 justify-center class="mt-2"><span> music  </span></v-layout>
                                                                </v-card>
                                                            </v-col>

                                                           <v-col cols="6" md="2" sm="1"  class="mt-sm-4 mt-0">
                                                                <v-card class="py-5 px-2 elevation-0">
                                                                   <v-img src="../../../assets/images/LevelTest/leveltest/school.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg4 md2 justify-center class="mt-2"><span> school  </span></v-layout>
                                                                </v-card>
                                                            </v-col>

                                                             <v-col cols="6" md="2" sm="1"   class="mt-sm-4 mt-0 ">
                                                                <v-card class="py-5 px-2 elevation-0">
                                                                   <v-img src="../../../assets/images/LevelTest/leveltest/cost.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg4 md2 justify-center class="mt-2"><span> cost  </span></v-layout>
                                                                </v-card>
                                                            </v-col>

                                                            <v-col cols="6" md="2" sm="1" class="mt-sm-4 mt-0 ">
                                                                <v-card class="py-5 px-2 elevation-0">
                                                                   <v-img src="../../../assets/images/LevelTest/leveltest/relax.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg4 md2 justify-center class="mt-2"><span> relax  </span></v-layout>
                                                                </v-card>
                                                            </v-col>

                                                           <v-col cols="6" md="2" sm="1"  class="mt-sm-4 mt-0">
                                                                <v-card class="py-5 px-2 elevation-0">
                                                                   <v-img src="../../../assets/images/LevelTest/leveltest/review.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg4 md2 justify-center class="mt-2"><span> review  </span></v-layout>
                                                                </v-card>
                                                            </v-col>

                                                            <v-col cols="6" md="2" sm="1"  class="mt-sm-4 mt-0">
                                                                <v-card class="py-5 px-2 elevation-0">
                                                                   <v-img src="../../../assets/images/LevelTest/leveltest/interact.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg4 md2 justify-center class="mt-2"><span> interact  </span></v-layout>
                                                                </v-card>
                                                            </v-col>
                                                            
                                                            
                                                        </v-row>
                                                    
                                                 
                                            </v-flex>
                                         </v-layout>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>






                             <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 4. Freetalking <span class="font-color1 font-weight-black"> 프리토킹</span> </span></p> 
                                
                                  <v-card class="px-2 py-lg-10 py-md-3 py-10 deep-purple lighten-5 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                         <div class="font-weight-bold"> 선생님이 다양한 주제에 대해 두 가지 질문을 할 때 가능한 답변해보세요. </div>
                                                        <div class="mt-2 text-body-2"> Your teacher will ask two (2) questions regarding various topics. Answer as best as you can.</div>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                        <v-layout row class="mt-5 px-3">
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="white px-5 py-5 elevation-0">
                                                    <div class="font-weight-bold"> 질문 예시 </div>
                                                    <div class="mt-2 text-body-2"> Sample Questions  </div>
                                                    <v-layout row class="mt-5 px-2">
                                                      <v-flex lg6 xs12>
                                                    <p >
                                                       1. What is your favorite restaurant?

                                                    </p>
                                                    <p >
                                                        2. What do you usually do as soon as you wake up?

                                                    </p>
                                                    <p >
                                                        3. What is your favorite food?

                                                    </p>
                                                    <p >
                                                     4. What is your favorite season?

                                                    </p>
                                                    <p >
                                                    5. When and where was your last vacation?

                                                    </p>
                                                    <p >
                                                     6. How do you celebrate the New Year?

                                                    </p>
                                                    </v-flex>
                                                    <v-flex lg6 xs12>
                                                          <p >
                                                       7. Where do you want to spend your summer vacation?

                                                    </p>
                                                    <p >
                                                       8. What is the most famous place for tourists in Korea? Why?

                                                    </p>
                                                    <p >
                                                        9. Where would you want to go right now? Why?

                                                    </p>
                                                    <p >
                                                    10. Why do you want to study English?

                                                    </p>
                                                    <p >
                                                    11. How can you help clean the Earth?

                                                    </p>
                                                    <p >
                                                     12. Why is the weather very unpredictable nowadays?

                                                    </p>

                                                    </v-flex>
                                                    </v-layout>
                                                  </v-card>
                                            </v-flex>

                                        </v-layout>
                                            
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                           
                            <v-container class="pb-lg-0 ">

                                 <v-flex lg12 xs12 class="text-center mt-lg-10 pb-2 pb-lg-0">
                                    <v-img src="@/assets/images/LevelTest/reports/mega_blue.png" aspect-ratio="1" max-height="100" contain></v-img>
                                   
                                    <div class="mt-5">

                                        <a @click="feedback()">
                                        <v-btn class="mx-2" fab dark color="rgb(186, 132, 255)">
                                            <v-icon dark class="text-lg-h2">
                                                mdi-chevron-right
                                            </v-icon>
                                        </v-btn>
                                       
                                        </a>
                                          <br/>
                                              <div class="mt-3  pb-lg-0"> Please give us a feedback! </div>

                                    </div>



                                </v-flex>

                                <floatIcon />

                            </v-container>

                      </v-layout>

                    </v-flex>
                </v-layout>
        </v-container>
    </v-app>
</template>
<script>
import floatIcon from '@/components/LevelTest/Report/floatIcon'
export default {
    name : 'PreviewMaterial',
      components:{
     floatIcon
    },
    methods:{
      back(){
           window.location.href="/leveltest?l_id="+this.$route.query.l_id
      },
      feedback(){
          this.$router.push({name:'feedbackformStudentNew',params:{l_id:this.$route.params.l_id}})
      }
    },
}
</script>
<style scoped>
.monsterrat{
   font-family: 'Montserrat', serif !important;
}
.font-color1{
  color:rgb(102,102,102)
}
</style>